import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponseWithPagination, GetQRsSchema, QRsResponseDataSchema } from "schema"
import { z } from "zod"

type Query = z.input<typeof GetQRsSchema> & { includeIds?: string[] | null }
type Response = DataResponseWithPagination<z.infer<typeof QRsResponseDataSchema>>
type OnSuccessFn = (data: Response) => void

const getQRsQueryKey = (query: Query = {}) => ["qr", query]

type Props = {
  query?: Query
  onSuccess?: OnSuccessFn
}

export const QRsQuery = ({ query, onSuccess }: Props) => {
  return queryOptions({
    queryKey: getQRsQueryKey(query),
    queryFn: async () => {
      const { data } = await axios.get<Response>("/integrations/qr", { params: query })

      if (query?.includeIds?.length) {
        const missingIds = query.includeIds.filter((id) => !data.data.some((e) => e.id === id))

        if (missingIds.length > 0) {
          const extraSearch = await axios.get<Response>("/integrations/qr", {
            params: {
              filterBy: {
                ids: missingIds,
              },
            },
          })

          const foundItems = extraSearch.data.data ?? []

          if (foundItems.length) {
            data.data.push(...foundItems)
          }
        }
      }

      onSuccess?.(data)
      return data.data
    },
  })
}
